import { css, html } from "lit";
import { state, query } from "lit/decorators.js";
import { ifDefined } from "lit-html/directives/if-defined.js";
import "../../atom/Icon/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { prop } from "../../../decorators/prop/index.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { getRootClasses } from "./utils.js";
import { rif } from "../../../helpers/renderIf.js";
import { TestingAttrs } from "./toggleButton.selectors.js";
import { testingAttr } from "../../../directives/testingAttr.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfToggleButton = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this._checked = false;
  }
  setChecked(checked) {
    this._checked = checked;
  }
  focus() {
    this.inputElement.focus();
    super.focus();
  }
  render() {
    const classes = getRootClasses(this._checked);
    const leftIcon = rif(
      this.dsf_icon_left,
      html`<dsf-icon class="h-16 w-16" dsf_name=${ifDefined(this.dsf_icon_left)}></dsf-icon>`
    );
    return html`
      <label class=${classes} data-skeleton>
        <input
          type="radio"
          value=${ifDefined(this.value)}
          .checked=${this._checked}
          class="absolute appearance-none outline-none"
          ${testingAttr(TestingAttrs.radioInput)}
        />
        ${leftIcon}
        <slot class="dsf-text-s truncate"></slot>
      </label>
    `;
  }
};
DsfToggleButton.styles = [
  ...BaseComponent.styles,
  css`
      :host(:first-child) > label {
        border-top-left-radius: calc(0.4 * var(--dsf-base-size));
        border-bottom-left-radius: calc(0.4 * var(--dsf-base-size));
      }
      :host(:last-child) > label {
        border-top-right-radius: calc(0.4 * var(--dsf-base-size));
        border-bottom-right-radius: calc(0.4 * var(--dsf-base-size));
      }
    `
];
__decorateClass([
  prop({ type: String })
], DsfToggleButton.prototype, "value", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfToggleButton.prototype, "dsf_icon_left", 2);
__decorateClass([
  state()
], DsfToggleButton.prototype, "_checked", 2);
__decorateClass([
  query("input")
], DsfToggleButton.prototype, "inputElement", 2);
DsfToggleButton = __decorateClass([
  defineElement("dsf-toggle-button")
], DsfToggleButton);
export {
  DsfToggleButton
};
